export interface EditionOptionConstant {
  value: string;
  name: string;
  category?: 'standard' | 'custom';
}

export const EDITION_OPTIONS: EditionOptionConstant[] = [
  // Editions standard - Journaux de paie
  { value: 'JP', name: 'Journal de paie', category: 'standard' },
  { value: 'JPS', name: 'Journal de paie par salarié', category: 'standard' },
  { value: 'TC', name: 'Tableau de charges', category: 'standard' },
  { value: 'TCS', name: 'Tableau de charges par salarié', category: 'standard' },

  // Editions standard - Bulletins
  { value: 'bulletin', name: 'Bulletin de paie', category: 'standard' },
  { value: 'bulletinSimp', name: 'Bulletin de paie simplifié', category: 'standard' },

  // Editions standard - Déclarations
  { value: 'DSN', name: 'DSN - Déclaration Sociale Nominative', category: 'standard' },
  { value: 'DSNM', name: 'DSN Mensuelle', category: 'standard' },
  { value: 'DSNA', name: 'DSN Arrêt de travail', category: 'standard' },
  { value: 'DSNFC', name: 'DSN Fin de contrat', category: 'standard' },

  // Editions standard - Etats
  { value: 'EtatCot', name: 'Etat des cotisations', category: 'standard' },
  { value: 'EtatCotD', name: 'Etat des cotisations détaillé', category: 'standard' },
  { value: 'EtatAbs', name: 'Etat des absences', category: 'standard' },
  { value: 'EtatCP', name: 'Etat des congés payés', category: 'standard' },
  { value: 'EtatHrs', name: 'Etat des heures', category: 'standard' },
  { value: 'EtatPrimes', name: 'Etat des primes', category: 'standard' },
  { value: 'EtatProvCP', name: 'Etat provisions congés payés', category: 'standard' },

  // Editions standard - Livres
  { value: 'LivreP', name: 'Livre de paie', category: 'standard' },
  { value: 'LivreC', name: 'Livre des charges', category: 'standard' },

  // Editions standard - Attestations
  { value: 'AttEmploi', name: "Attestation d'emploi", category: 'standard' },
  { value: 'AttSal', name: 'Attestation de salaire', category: 'standard' },
  { value: 'AttSalMal', name: 'Attestation de salaire maladie', category: 'standard' },
  { value: 'AttSalMat', name: 'Attestation de salaire maternité', category: 'standard' },
  { value: 'AttSalAT', name: 'Attestation de salaire AT', category: 'standard' },
  { value: 'CertTrav', name: 'Certificat de travail', category: 'standard' },

  // Editions standard - Solde de tout compte
  { value: 'STC', name: 'Solde de tout compte', category: 'standard' },
  { value: 'RecuSTC', name: 'Reçu pour solde de tout compte', category: 'standard' },

  // Editions standard - Registres
  { value: 'RegPers', name: 'Registre du personnel', category: 'standard' },

  // Editions standard - DADS / N4DS
  { value: 'DADS', name: 'DADS-U', category: 'standard' },
  { value: 'N4DS', name: 'N4DS', category: 'standard' },

  // Editions standard - Provisions
  { value: 'ProvCP', name: 'Provisions congés payés', category: 'standard' },
  { value: 'Prov13', name: 'Provisions 13ème mois', category: 'standard' },

  // Editions standard - Exports comptables
  { value: 'ExpCompta', name: 'Export comptable', category: 'standard' },
  { value: 'EcritCompt', name: 'Ecritures comptables', category: 'standard' },
  { value: 'ExpComptaAnal', name: 'Export comptable analytique', category: 'standard' },

  // Editions standard - DUCS / Déclarations
  { value: 'DUCS', name: 'DUCS', category: 'standard' },
  { value: 'DUCSU', name: 'DUCS URSSAF', category: 'standard' },
  { value: 'DUCSR', name: 'DUCS Retraite', category: 'standard' },

  // Editions standard - Tableaux récapitulatifs
  { value: 'TabRecap', name: 'Tableau récapitulatif', category: 'standard' },
  { value: 'TabRecapAn', name: 'Tableau récapitulatif annuel', category: 'standard' },

  // Editions standard - Virements
  { value: 'OrdVir', name: 'Ordre de virement', category: 'standard' },
  { value: 'SEPA', name: 'Fichier SEPA', category: 'standard' },

  // Editions standard - Masse salariale
  { value: 'MassSal', name: 'Masse salariale', category: 'standard' },
  { value: 'MassSalD', name: 'Masse salariale détaillée', category: 'standard' },

  // Editions standard - Documents divers
  { value: 'FichInd', name: 'Fiche individuelle', category: 'standard' },
  { value: 'ContTrav', name: 'Contrat de travail', category: 'standard' },
  { value: 'AVS', name: 'Avenant au contrat', category: 'standard' },
  { value: 'DUE', name: "Déclaration unique d'embauche", category: 'standard' },
  { value: 'DocFin', name: 'Documents de fin de contrat', category: 'standard' },

  // Editions standard - Taxes
  { value: 'TaxApp', name: "Taxe d'apprentissage", category: 'standard' },
  { value: 'TaxFC', name: 'Taxe formation continue', category: 'standard' },
  { value: 'FPC', name: 'Formation professionnelle continue', category: 'standard' },
  { value: 'AGEFIPH', name: 'Contribution AGEFIPH', category: 'standard' },
  { value: 'EfFort', name: 'Effort de construction', category: 'standard' },

  // Editions standard - Intéressement / Participation
  { value: 'Participation', name: 'Participation', category: 'standard' },
  { value: 'Interessement', name: 'Intéressement', category: 'standard' },

  // Editions standard - Mutuelle / Prévoyance
  { value: 'DecMut', name: 'Déclaration mutuelle', category: 'standard' },
  { value: 'DecPrev', name: 'Déclaration prévoyance', category: 'standard' },

  // Editions standard - Reporting
  { value: 'BDES', name: 'BDES', category: 'standard' },
  { value: 'BilanSoc', name: 'Bilan social', category: 'standard' },
  { value: 'IndexEga', name: 'Index égalité F/H', category: 'standard' },

  // Editions standard - Autre
  { value: 'EtatAn', name: 'Etat annuel', category: 'standard' },
  { value: 'RecapAn', name: 'Récapitulatif annuel', category: 'standard' },
  { value: 'PVElec', name: 'PV élections CSE', category: 'standard' },
];
